<template>
    <div class="checkout">
        <Navbar />
        <section class="py-4 bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 align-self-center">
                        <h3 class="mb-3">Login to Checkout</h3>
                        <LoginForm />
                    </div>
                    <div class="col-lg-2 align-self-center text-lg-center my-lg-0 my-4">
                        OR
                    </div>
                    <div class="col-lg-5 align-self-center d-flex flex-column">

                        <h3 class="mb-3">Don't have an account?</h3>

                        <RegisterForm redirect="/checkout"/>
                    </div>
                </div>
            </div>
        </section>

        <Footer />
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.create-account-form {
    .checkbox {
        font-weight: 400;
    }

    .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
        &:focus {
            z-index: 3;
        }
    }

    .input-group > .form-control:not(:first-child),
    .input-group > .custom-select:not(:first-child) {
        border-bottom-left-radius: 4px;
    }

    .input-group .btn {
        border-top-right-radius: 0;
    }

    input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    input[type="password"] {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    input.is-invalid {
        z-index: 5;
    }
}
</style>

<script>


import RegisterForm from "@/components/RegisterForm";
import LoginForm from "@/components/LoginForm";
import Navbar from "@/components/Navbar";
export default {
    name: 'dashboard',
    components: {
        Navbar,
        LoginForm,
        RegisterForm,
    },
}
</script>
